import api from '../api';

export function listSlides(storyId) {
    return api.get(`/slides?story_id=${storyId}`).then(response => response.data);
}

export function getSlide(slideId) {
    return api.get(`/slides/${slideId}`).then(response => response.data);
}

export function createSlide(storyId, type = null) {
    return api.post(`/slides`, {
        'story_id': storyId,
        'type': type
    }).then(response => response.data);
}

export function editSlide(slideId, data) {
    return api.put(`/slides/${slideId}`, {
        'data': data
    }).then(response => response.data);
}

export function removeSlide(slideId) {
    return api.delete(`/slides/${slideId}`).then(response => response.data);
}

export function moveSlide(slideId, position) {
    return api.post(`/slides/${slideId}/move`, {
        'position': position
    }).then(response => response.data);
}

export function duplicate(slideId) {
    return api.post(`/slides/${slideId}/duplicate`).then(response => response.data);
}
